import Vue from 'vue';
import $ from 'jquery';
import moment from 'moment';
import eventHub from './../../bankrate-events';
import utilities from './../../utility/vue-common';
import config from './../../bankrate-rate-tables/envConfig';
import data from './data';
import termsData from './data/terms';
import sortData from './data/sort';
import loanTypesData from './data/loanTypes';
import dateInput from 'apps/components/date-input.vue';
import feesAndConditions from 'apps/legacy-components/fees-and-conditions.vue';
import findARate from './components/find-a-rate.vue';
import interestInput from './components/interest-input.vue';
import lenderInfo from 'apps/components/lender-info.vue';
import lodashOrderBy from 'lodash.orderby';
import rtAmount from '../../legacy-components/rt-amount.vue';
import rtAmountMobile from '../../legacy-components/rt-amount-mobile.vue';
import rtCalcLinkCard from '../../components/rt-calc-link-card.vue';
import rtDropdown from '../../legacy-components/rt-dropdown.vue';
import rtRowCpc from '../../legacy-components/rt-row-cpc.vue';
import rtRowCpcMobile from '../../legacy-components/rt-row-cpc-mobile.vue';
import rtRowDisclosure from '../../legacy-components/rt-row-disclosure.vue';
import rtSort from '../../legacy-components/rt-sort.vue';
import './eventAnalytics';
import './../../bankrate-events/rate-table';

let template = utilities.methods.isDesktop() ? require('./template.html') : require('./mobile-template.html');
let endPoint = config.setEndpoint("Auto");

Vue.component('calculator-auto', {
    template: template,
    mixins: [data, termsData, loanTypesData, sortData, utilities],

    components: {
        feesAndConditions: feesAndConditions,
        lenderInfo: lenderInfo,
        interestInput: interestInput,
        findARate: findARate,
        dateInput: dateInput,
        rtAmount: rtAmount,
        rtAmountMobile: rtAmountMobile,
        rtCalcLinkCard: rtCalcLinkCard,
        rtDropdown: rtDropdown,
        rtRowCpc: rtRowCpc,
        rtRowCpcMobile: rtRowCpcMobile,
        rtRowDisclosure: rtRowDisclosure,
        rtSort: rtSort
    },

    props: ['initzipcode', 'viewSearchDefaults', 'viewRates'],

    data: function () {
        return {
            parameters: {
                amount: null,
                prods: null,
                zipmarket: null
            },
            searchDefaults: '',
            rates: '',
            amount: null,
            amortizationSchedule: '',
            showAmortizationSchedule: false,
            loanType: '',
            interestRate: 3.00,
            isLenderRate: '',
            selectedLender: '',
            prods: null,
            limit: null,
            offset: null,
            method: null,
            zipMarket: null,
            market: '',
            marketDisplayed: '',
            calculatorResults: {
                amortizationSchedule: '',
                estimatedPayment: 0,
                estimatedPayoffDate: '',
                totalInterest: 0,
                totalPrinciple: 0
            },
            amortizationProps: {
                additionalMonthlyPayment: 0,
                payment: 0,
                loanStartDate: ''
            },
            sort: {
                field: '',
                ascending: true
            },

            showLoader: false,
            initialLoad: true
        };

    },

    computed: {

        /**
         * @return {number}
         */
        isAscending: function () {
            return this.sort.ascending ? 1 : -1;
        },

        /**
         * Determines whether or not a rate it specific to a selected lender
         * (Used in template)
         * @return {boolean|*}
         */
        isLenderSpecific: function () {
            return this.isLenderRate && this.selectedLender;
        },

        /**
         * @return {*}
         */
        ratesSorted: function () {
            if (!this.resultsReady()) {
                return [];
            }

            let sortData = this.arrayObjectIndexOf(this.sortByData, 'field', this.sort.field);

            if (sortData) {
                let fields = [typeof this.sort.field === 'object' ? this.sort.field.join('.') : this.sort.field].concat(
                    typeof sortData.item.multi !== 'undefined' ? sortData.item.multi.fields : []
                );
                let order = [this.sort.ascending ? 'asc' : 'desc'].concat(
                    typeof sortData.item.multi !== 'undefined' ? sortData.item.multi.order : []
                );

                /*
                 * lodash is case sensitive - it can sort by the field name OR a function,
                 * so we pass a function that does a lower-case conversion.
                 */
                if (fields[0] === 'advertiser') {
                    fields[0] = function (i) {
                        return i.advertiser.toLowerCase();
                    };
                }
                this.rates.products = lodashOrderBy(this.rates.products, fields, order);
            }
            return this.rates.products;
        },

        /**
         * Returns the product title of the current product
         * (Used in template)
         * @return string
         */
        currentProductHeader: function() {
            if (this.rates.products && this.rates.products.length !== 0) {
                return this.rates.products[0].product.toString();
            }
            return '';
        },

        /**
         * set Prods Displayed on rate table for data collector
         *
         */
        prodsDisplayed: function () {
            if (this.rates.products) {
                this.prodsDisplayedArray = [];
                // display productids actually shown on table & remove duplicates
                for (let i = 0, ilen = this.rates.products.length; i < ilen; i++) {
                    this.prodsDisplayedArray = this.prodsDisplayedArray.concat([this.rates.products[i].productuid]);
                }
                this.prodsDisplayedArray = this.prodsDisplayedArray.filter(function(item, pos, self) {
                    return self.indexOf(item) === pos;
                });
                return this.prodsDisplayedArray;
            }
        }
    },

    created: function () {
        eventHub.$on('sort::change', this.sortingChange);
        eventHub.$on('updateAmount', this.updateAmount);
        eventHub.$on('updateLocation', this.updateLocation);
        eventHub.$on('dropDown::change', this.handleDropwdownChange);
        eventHub.$on('calculator::setInterestRate', this.updateInterestRate);
        eventHub.$on('findARate::change', this.updateLenderProvidedRate);
        eventHub.$on('autoCalc::toggleAmortization', this.toggleAmortizationSchedule);
        eventHub.$on('dateInput::updated', this.updateLoanStartDate);

        this.searchDefaults = JSON.parse(this.viewSearchDefaults);

        if (this.initzipcode && this.initzipcode.length > 0) {
            this.searchDefaults.zipMarket = this.initzipcode;
        }

        if (this.rates !== '') {
            this.rates = JSON.parse(this.viewRates);
        } else {
            this.showLoader = true;
        }
        this.processParameters();
        this.prepareDefaults();
        this.updateLoanStartDate();

        eventHub.$on('pid.loaded', function (pid) {
            this.searchDefaults.pid = pid;

            if (this.rates === '') {
                this.apiCall();
            } else {
                this.prepareLocation();
                this.$nextTick(function () {
                    this.emitSortData('ratetableUpdated.ratesLoaded');
                });
                this.initialLoad = false;
                this.limit = this.searchDefaults.initialLimit;
                this.offset = this.searchDefaults.offset;
            }

        }.bind(this));
    },

    mounted: function() {
        this.mediaAlphaWidthAdjuster()
    },

    watch: {
        'rates.results': function () {
            if (this.resultsReady()) {
                this.pagination.show = this.rates.pageInfo.offset + this.rates.products.length;
                this.pagination.total = this.rates.pageInfo.totalRecords;
                this.pagination.next =
                    this.pagination.total - this.pagination.show < this.searchDefaults.limit
                        ? this.pagination.total - this.pagination.show
                        : this.searchDefaults.limit
                ;
            }
        }
    },

    methods: {

        /**
         * Get parameters from the URL and save them to local data
         */
        processParameters: function () {
            this.parameters.amount = this.getParameter('amount');
            this.parameters.zipmarket = this.getParameter('zip');
        },

        /**
         * Get passed parameter from query string
         * @param param
         * @returns {*}
         */
        getParameter: function (param) {
            let arg = parseInt(this.getParameterByName(param));
            if (arg !== null && !isNaN(arg)) {
                return arg;
            }

            return null;
        },

        /**
         * This method verifies the existence of results for this.rates
         * Once the AJAX call is made, this.rates has data
         * @returns {boolean}
         */
        resultsReady: function () {
            return typeof this.rates.products !== 'undefined' && this.rates.products.length > 0;
        },

        /**
         * This method build the conditional class active for each td of the table
         * The class active is used to highlight the current row affected by the sorting
         * @param field
         * @returns {string}
         */
        isRowSelected: function (field) {
            return this.sort.field === field ? '--is-active' : '';
        },

        /**
         * @param id
         * @return {string}
         */
        isActiveClass: function (id) {
            return this.summaryActiveProd === id ? '--is-active' : '';
        },

        /**
         * @param id
         */
        activeClass: function (id) {
            this.showMobileBestRates = false;
            if (typeof id === 'number') {
                this.summaryActiveProd = id;
                this.isActiveClass(id);
            }
        },

        /**
         * Listening from rt-sort components clicks
         * @param eventData
         */
        sortingChange: function (eventData) {
            this.sort = eventData.data;
            // Update drop-down with current sorting option
            this.sortSingleSelected = {field: this.sort.field, ascending: eventData.default};
            this.$nextTick(function () {
                eventHub.$emit(
                    'ratetableUpdated.sorted',
                    Array.isArray(this.sort.field) ? this.sort.field.join('.') : this.sort.field, this.sort.ascending
                );
            });
        },

        /**
         * Handle change of dropdown inputs
         */
        handleDropwdownChange: function (dropdown) {
            if (dropdown.uniqueId === 'loanTerm') {
                this.termsItemsSelected = dropdown.selected;
                eventHub.$emit('autoCalc::setTerm', this.termsItemsSelected);
            } else if (dropdown.uniqueId === 'loanType') {
                this.loanTypeSelected = dropdown.selected;
                this.handleLoanTypeChange();
                eventHub.$emit('autoCalc::setLoanType', this.loanTypeSelected);
            }
            this.setProductIdsBySelections();
            this.apiCall(false, 'ratetableUpdated.filtered');
            this.setPaymentData();
        },

        /**
         * Determine what term lengths to show based on loan type selected
         */
        handleLoanTypeChange: function () {
            let allTerms = [];
            this.termsData.forEach((el) => {
                allTerms.push(el);
            });
            this.termsItems = allTerms;
            if (this.loanTypeSelected === 'used') {
                let unavailableProdKey = this.arrayObjectIndexOf(this.termsItems, 'value', 72).index;
                this.termsItems.splice(unavailableProdKey, 1);
            }
        },

        /**
         * Update loan amount
         * @param amount
         */
        updateAmount: function (amount) {
            this.amount = amount;
            eventHub.$emit('autoCalc::setLoanAmount', this.amount);
            this.apiCall(false, 'ratetableUpdated.filtered');
            this.setPaymentData();
        },

        /**
         * Update location
         * @param loc
         */
        updateLocation: function (loc) {
            this.zipMarket = loc;
            eventHub.$emit('autoCalc::setLocation', loc);
            this.apiCall(false, 'ratetableUpdated.filtered');
            // does this still need to be a functionality for the calculator?
        },

        /**
         * Update user entered interest rate
         * @param rate
         */
        updateInterestRate: function (rate) {
            eventHub.$emit('findARate::reset');
            this.isLenderRate = false;
            this.setInterestRate(rate);
            this.setPaymentData();
        },

        /**
         * Update lender provided interest rate
         * @param lender
         */
        updateLenderProvidedRate: function (lender) {
            // Specific to "find a rate" module
            this.isLenderRate = true;
            this.selectedLender = lender;
            this.setProductIdsBySelections();
            this.setInterestRate(lender.apr);
            this.setPaymentData();
        },

        /**
         * Update the Loan start date based on term
         * @param date
         */
        updateLoanStartDate: function (date) {
            let startDate = date ? date : moment();
            this.amortizationProps.loanStartDate = startDate.format('MM/DD/YYYY');
            this.setPaymentData();
        },

        /**
         * Calculate estimated loan payment
         * @param amount
         * @param interestRate
         * @param months
         * @return {string}
         */
        calculatePayment: (amount, interestRate, months) => {
            let a = parseFloat(amount);
            let rate = parseFloat(interestRate) / 1200;
            let m = parseInt(months);
            /*eslint-disable */
            return (a * rate / (1 - (Math.pow(1 / (1 + rate), m))));
            /*eslint-enable */
        },


        /**
         * Set interest rate
         * @param rate
         */
        setInterestRate: function(rate) {
            this.interestRate = parseFloat(rate);
        },

        /**
         * Set estimated payment
         */
        setPaymentData: function() {
            this.calculatorResults.totalInterest = 0;
            this.calculatorResults.estimatedPayment = this.calculatePayment(this.amount, this.interestRate, this.termsItemsSelected);
            this.calculatorResults.amortizationSchedule = this.createAmortizationSchedule(this.amount, this.interestRate, this.termsItemsSelected, this.calculatorResults.estimatedPayment);
            this.calculatorResults.estimatedPayoffDate = this.getEstimatedPayoffDate(this.amortizationProps.loanStartDate, this.termsItemsSelected);
        },

        /**
         * Get estimated payoff date based
         * Term must be formatted by months
         * @param loanStartDate
         * @param term
         * @return {*}
         */
        getEstimatedPayoffDate: (loanStartDate, term) => {
            let payoffDate = '';
            let startDate = moment(loanStartDate, 'MM/DD/YYYY');
            if (startDate) {
                payoffDate = startDate.add(term, 'months').format("MMMM Do, YYYY");
            } else {
                payoffDate = moment().add(term, 'months').format("MMMM Do, YYYY");
            }
            return payoffDate;
        },

        /**
         * The multi-selection portion of the terms drop-down needs to be filled depending of the current group
         */
        prepareDefaults: function () {
            this.prepareLoanTypesDropdown();
            this.prepareTermsDropdown();
            this.prepareAmount();
            this.prods = this.searchDefaults.prods;
        },

        /**
         * Set default amount if no amount specified
         */
        prepareAmount: function () {
            this.amount = this.amount || this.searchDefaults.amount;
            eventHub.$emit('autoCalc::setLoanAmount', this.amount);
        },

        /**
         * Set terms dropdown and default selections
         */
        prepareTermsDropdown: function() {
            let allTerms = [];
            let selectedTerm = '';
            this.termsData.forEach((el) => {
                allTerms.push(el);
                if (el.default === true) {
                    selectedTerm = el.value;
                }
            });
            this.termsItems = allTerms;
            this.termsItemsSelected = selectedTerm;
            if (this.loanTypeSelected === 'used') {
                let unavailableProdKey = this.arrayObjectIndexOf(this.termsItems, 'value', 72).index;
                this.termsItems.splice(unavailableProdKey, 1);
            }
            eventHub.$emit('autoCalc::setTerm', this.termsItemsSelected);
        },

        /**
         * Set loan type dropdown and default selections
         */
        prepareLoanTypesDropdown: function () {
            let loanTypes = [];
            let loanTypeSelected = '';

            this.loanTypeData.forEach((el) => {
                loanTypes.push(el);
                loanTypeSelected = el.value;
            });

            this.loanTypeItems = loanTypes;
            this.loanTypeSelected = loanTypeSelected;
            eventHub.$emit('autoCalc::setLoanType', this.loanTypeSelected);
        },

        /**
         * Set location input a default location
         */
        prepareLocation: function () {
            this.market = this.rates && this.rates.metadata && this.rates.metadata.MarketId || '';
            this.marketDisplayed = this.rates.metadata.Market + ", " + this.rates.metadata.StateCode;

            let initZipMarket = this.zipMarket; // Check if the market has changed from the initial page load
            let zipMarket = this.zipMarket || this.searchDefaults.zipMarket;
            let marketBlend = !(/^\d{5}(?:[-\s]\d{4})?$/).test(zipMarket) ? 'market/' : '';
            if (marketBlend || initZipMarket === null) {
                eventHub.$emit('locationUpdated', this.marketDisplayed);
            } else {
                eventHub.$emit('locationUpdated', zipMarket);
            }
        },

        /**
         * Set product ids to application based on selected dropdown values
         */
        setProductIdsBySelections: function() {
            let filteredItems = this.products;
            let selectedTerm = this.termsItemsSelected;
            let selectedType = this.loanTypeSelected;

            let filterByTerm = (value) => {
                return selectedTerm === value.months;
            };

            let filterByLoanType = (value) => {
                return selectedType === value.purchaseType;
            };

            filteredItems = filteredItems.filter(filterByTerm);
            filteredItems = filteredItems.filter(filterByLoanType);
            this.prods = [filteredItems[0].id];
        },

        /**
         * Emit generic sort events
         * @param eventName
         */
        emitSortData: function (eventName) {
            eventHub.$emit(
                eventName,
                {
                    'sort': Array.isArray(this.sort.field) ? this.sort.field.join('.') : this.sort.field,
                    'isAscending': this.sort.ascending,
                    'initialLoad': this.initialLoad
                }
            );
        },

        /**
         * AJAX request to Auto API
         * @param mergeRates
         * @param eventName
         */
        apiCall: function (mergeRates, eventName) {
            mergeRates = mergeRates || false;
            eventName = eventName || 'ratetableUpdated.ratesLoaded';
            // Clear old results
            if (!mergeRates) {
                this.limit = this.searchDefaults.initialLimit;
                this.offset = this.searchDefaults.offset;
                this.showLoader = true;
                this.rates = {};
            } else {
                this.offset += this.limit;
                this.limit = this.searchDefaults.limit;
            }
            let products = this.prods.join(',') || this.searchDefaults.prods.join(',');
            let zipMarket = this.zipMarket || this.searchDefaults.zipMarket;
            let marketBlend = !(/^\d{5}(?:[-\s]\d{4})?$/).test(zipMarket) ? 'market/' : '';
            let amount = this.amount || this.searchDefaults.amount;
            let cobrand = this.searchDefaults.pid;
            let url = endPoint
                + marketBlend
                + products + '/'
                + zipMarket + '/'
                + amount + '?'
                + 'cobrand=' + cobrand;

            let timingObject = {
                url: url,
                startTime: window.performance.now()
            };
            $.ajax({
                url: url,
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Authorization': 'basic YnIzOjRjN3RkYnk4aWo3bA=='
                },
                complete: function(jqXHR, textStatus){
                    "use strict";
                    timingObject.endTime = window.performance.now();
                    eventHub.$emit('ratetableRequestEnd', timingObject);
                },
                success: function (rates) {
                    this.showLoader = false;

                    if (mergeRates) {
                        this.mergeRates(rates);
                    } else {
                        this.rates = rates;
                        this.rates.products = this.removeEditorialRates(rates.products[0]);
                    }
                    this.prepareLocation();
                    this.$nextTick(function () {
                        if (this.initialLoad) {
                            this.initialLoad = false;
                        }
                        this.emitSortData(eventName);
                        eventHub.$emit('findARate::refreshLenderRate');
                    });
                }.bind(this),
                error: function (jqXHR, textStatus, errorThrown) {
                    this.showLoader = false;
                    this.rates = {};
                    eventHub.$emit('ratetableError', 'API call failed');
                }.bind(this)
            });
        },

        /**
         * Remove editorial advertisers from product array
         * @param rates
         * @return {Array}
         */
        removeEditorialRates: rates => {
            let paidListings = [];
            for (let i = 0; i < rates.length; i++) {
                if (rates[i].ispaid === true || rates[i].ispaid === "True") {
                    paidListings.push(rates[i]);
                }
            }

            return paidListings;
        },

        /**
         * Merge rates
         * @param rates
         */
        mergeRates: function (rates) {
            this.rates.products = this.rates.products.concat(rates.results);
        },

        /**
         * Create amortization schedule and return as array of objects
         * @param loanAmount
         * @param interesetRate
         * @param months
         * @param payment
         * @return {Array}
         */
        createAmortizationSchedule: function(loanAmount, interesetRate, months, payment) {
            let schedule = [];
            let remaining = parseFloat(loanAmount);
            let totalInterest = 0;
            let additionalMonthlyPayment = this.amortizationProps.additionalMonthlyPayment;
            let totalMonthlyPayment = payment + additionalMonthlyPayment;
            let paymentDate = this.amortizationProps.loanStartDate ? moment(this.amortizationProps.loanStartDate, 'MM/DD/YYYY') : moment();
            for (let i = 0; i <= months; i++) {

                let interest = remaining * (interesetRate / 100 / 12);
                let principal = totalMonthlyPayment - interest;
                totalInterest += interest;
                let row = {
                    'row': i,
                    'payment': totalMonthlyPayment > 0 ? totalMonthlyPayment : 0,
                    'paymentDate': paymentDate.format('MM/DD/YY'),
                    'principal': principal > 0 ? principal.toFixed(2) : 0,
                    'interest': interest > 0 ? interest.toFixed(2) : 0,
                    'remaining': remaining > 0 ? remaining.toFixed(2) : 0,
                    'totalInterest': totalInterest
                };
                paymentDate = paymentDate.add(1, 'month');
                if (parseFloat(remaining.toFixed()) >= 0) {
                    schedule.push(row);
                    remaining -= principal;
                }
            }
            // TODO: Total paid interest is coming back incorrectly at this assignment
            this.calculatorResults.totalInterest += Math.round(totalInterest);
            return schedule;
        },

        /**
         * Hide or show amortization schedule
         */
        toggleAmortizationSchedule: function () {
            this.showAmortizationSchedule = !this.showAmortizationSchedule;
            if (this.showAmortizationSchedule === true) {
                eventHub.$emit('autoCalc::showAmortization');
            }
        },

        /**
         * Print amortization schedule
         * (Used in template)
         */
        printAmortizationSchedule: function() {
            let table = document.querySelector('[data-table=amortization]');
            let printWindow = window.open('');
            printWindow.document.write(table.outerHTML);
            printWindow.print();
            printWindow.close();
        },

        mediaAlphaWidthAdjuster: function() {
            let _updateTableWidth = () => {
                let grid = this.$el.querySelector('.js-media-alpha');

                if(grid) {
                    let dimensions = grid.getBoundingClientRect();
                    let widget = document.getElementById('media-alpha-calculator-snippet');
                    // Subtract 28px for page wrapper padding
                    widget.setAttribute('style', 'width: ' + (dimensions.width - 28) + 'px');
                }
            }

            let mediaAlpha = this.$el.querySelector('.js-media-alpha');

            if(mediaAlpha) {
                _updateTableWidth();
                window.addEventListener('resize', _updateTableWidth);
            }
        }
    }
});
